// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".not_dragging[data-v-ad2a1ba4]{display:none}", ""]);
// Exports
module.exports = exports;
